import React, { Component } from "react";
import { VictoryPie } from "victory";
import Parser from "html-react-parser";
import "./pie_style.css";
/*jshint -W065 */
import CreatePdf from "./../custom/CreatePdf";

var results;

export default class Zoom extends Component {
  constructor(props) {
    super(props);
    // console.log("results.length", this.props);
    results = this.props.record.results;
    if (!results) {
      try {
        results = JSON.parse(this.props.record.surveyID.results);
      } catch (err) {
        results = new Array();
        console.log(err);
      }
    }
  } 
  render() {
    // console.log("propsPieRecord",this.props.record);
    const title = this.props.record.surveyID.title;
    const perce = this.props.record.perce;
    const age = this.props.record.age;
    const gender = this.props.record.gender;

    var filters = ""; //Αποτελεσμα για {gender} και {age}
    if (gender || age) {
      // filters = "Αποτελεσμα για " + gender + " " + age;
      filters = `Αποτελέσματα για ${gender ? `Φύλο: ${gender}` : ""}  ${
        age ? `Ηλικίες: ${age}` : ""
      }`;
    }

    var question = Array();
    var sum_array = Array();
    var sum = 0;
    if (results.length > 0) {
      for (var i = 0; i < results.length; i++) {
        if (results[i][0]) {
          question.push(Parser("Ερώτηση " + (i + 1) + results[i][0].question));
          // question.push(Parser("" + results[i][0].question));
        }
      }

      for (var x = 0; x < results.length; x++) {
        var inner_res = results[x];
        sum = 0;
        for (var y = 0; y < inner_res.length; y++) {
          sum = sum + parseInt(inner_res[y].y, 10);
        }
        //console.log("sum_array", sum_array);
        sum_array.push(sum);
      }
    }
    return (
      <span>
        {filters && (
          <h1
            className="pos"
            style={{
              // position: "fixed",
              // background: "rgb(0, 188, 212)",
              // padding: "20px",
              // zIndex: "1000",
              // fontSize: "25px",
              // fontWeight: "900",
              // color: "#fff",
              // left: "50%",
              // top: "180px"
            }}
          >
          </h1>
        )}
        {results.map(function(object, i) {
          return (
            <pdfblock id="help{i}" className="createPDFBlock" >
              <h1 className="pos">{title ? title : ""}</h1>
              <h2 className="pos">{question[i]}</h2>
              <div className="place_next">
                <h3 className="pos">Αποτελέσματα</h3>
                {object.map(function(object_2, k) {
                  // { console.log("object_2",object_2) }
                  if (object_2.y !== 0) {
                    //console.log("sum",parseInt((100/sum_array[k]) * parseInt(object_2.y,10),10));
                    // console.log("[k]", k);
                    // console.log("object_2.y", object_2.y);
                    return (
                      <h3>
                        {" " + object_2.x + ": " + object_2.y + " "}({parseFloat(
                          (100 / sum_array[i]).toFixed(2) *
                            parseFloat(object_2.y, 10).toFixed(2),
                          10
                        ) + "%"})
                      </h3>
                    );
                  } else {
                    return <h3>""</h3>;
                  }
                })}
                <h3 className="pos">Απάντησαν: {perce}</h3>
                <h3 className="pos">Συμμετοχές: {sum_array[i]}</h3>
                <h3 className="pos">{ filters ? filters : "" }</h3>
              </div>
              <p style={{ width: "50%", height: "auto" }}>
                {object.length === 0 && (
                  <h1 className="pos">Δεν βρέθηκαν αποτελέσματα</h1>
                )}
                <VictoryPie
                  colorScale={[
                    "#3CA9E5 ",
                    "#FFFF0D",
                    "#E88E0C",
                    "#80C8E7",
                    "#FF0000"
                  ]}
                  data={object}
                  labelRadius={90}
                  labels={d => d.y}
                  style={{
                    labels: { fill: "white", fontSize: 20, fontWeight: "bold" }
                  }}
                />
              </p>
              <CreatePdf />
            </pdfblock>
          );
        })}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/custom/ShowPie.js